/* EG Collections — Tag UI (render EG tag groups/sets, counts + disabled state) */

function egGetNumericSliderCfgForStartsWith(startsWith) {
  var cfg = window.EG_NUMERIC_TAG_SLIDERS || {};
  var sw = String(startsWith || "");
  for (var k in cfg) {
    if (!cfg.hasOwnProperty(k)) continue;
    var c = cfg[k];
    if (c && String(c.prefix || "") === sw) return c;
  }
  return null;
}

function egGetNumericRangeFromUrl(param, minVal, maxVal) {
  var sp = new URLSearchParams(window.location.search || "");
  var v = String(sp.get(param) || "");

  // ALSO support pretty key (?length=...) when param is eg_range_length
  if (!v) {
    var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
    for (var rk in sliders) {
      if (!sliders.hasOwnProperty(rk)) continue;
      var sc = sliders[rk];
      if (sc && String(sc.param || "") === String(param)) {
        v = String(sp.get(String(rk)) || "");
        break;
      }
    }
  }

  if (!v) return { min: minVal, max: maxVal };

  var nums = String(v || "").match(/-?\d+(\.\d+)?/g) || [];
  if (nums.length < 2) return { min: minVal, max: maxVal };

  var a = parseFloat(nums[0]);
  var b = parseFloat(nums[1]);
  if (isNaN(a) || isNaN(b)) return { min: minVal, max: maxVal };

  return { min: Math.max(minVal, Math.min(a, b)), max: Math.min(maxVal, Math.max(a, b)) };
}

function egSetUrlParamNoReload(key, value) {
  var u = new URL(window.location.href);
  var sp = u.searchParams;

  // If we're writing a long range key (eg_range_length), delete its pretty key (length) first
  try {
    if (String(key).indexOf("eg_range_") === 0) {
      var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
      for (var rk in sliders) {
        if (!sliders.hasOwnProperty(rk)) continue;
        var sc = sliders[rk];
        if (sc && String(sc.param || "") === String(key)) {
          sp.delete(String(rk)); // delete pretty key: length/width/etc
          break;
        }
      }
    }
  } catch (e1) {}

  if (!value) sp.delete(key);
  else sp.set(key, value);

  u.search = sp.toString();
  history.replaceState({}, "", u.toString());

  // Keep address bar prettified after any URL mutation
  if (typeof egApplyPrettyUrlToAddressBar === "function") {
    try { egApplyPrettyUrlToAddressBar(); } catch (e2) {}
  }
}

function egApplyColourSwatches(root) {
  if (!root) return;

  var map = window.EG_COLOR_SWATCH_MAP || {};
  var groups = root.querySelectorAll('.eg-filter-group[data-eg-kind="tag"][data-eg-tag-group], .eg-filter-group[data-eg-kind="tagset"]');
  if (!groups || !groups.length) return;

  // Find any checkboxes that are "Colour" (by group label or key)
  // We support both:
  // - group key equals "colour"
  // - visible heading text equals "Colour"
  var inputs = root.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"]');
  for (var i = 0; i < inputs.length; i++) {
    var cb = inputs[i];
    var groupKey = String(cb.getAttribute("data-eg-tag-group") || cb.dataset.egTagGroup || "");
    if (!groupKey) continue;

    // only apply to colour group
    if (groupKey.toLowerCase() !== "colour") continue;

    var label = cb.closest ? cb.closest("label.eg-filter-option") : null;
    if (!label) continue;

    // Identify the text node element for the option label
    var textEl =
      label.querySelector(".eg-filter-option-text") ||
      label.querySelector(".eg-filter-option-label") ||
      label;

    var valueText = "";
    try { valueText = (textEl.textContent || "").replace(/^\s+|\s+$/g, ""); } catch (e) {}
    if (!valueText) continue;

    // Apply display rename (Colour group)
    var ren = window.EG_FILTER_VALUE_RENAMES || {};
    var groupRen = ren["colour"] || {};
    var displayText = groupRen[valueText] || valueText;

    // Update visible label text to renamed version (but do NOT touch input value)
    if (displayText !== valueText) {
      // Only replace the visible text node, keep count spans etc intact
      // If your label uses a dedicated text span, update that.
      var txtTarget = label.querySelector(".eg-filter-option-text") || label.querySelector(".eg-filter-option-label");
      if (txtTarget) {
        txtTarget.textContent = displayText;
      } else {
        // Fallback: if label text is plain, set it (may include extra whitespace)
        textEl.textContent = displayText;
      }
    }

    // avoid double-inserting
    if (label.querySelector(".eg-colour-swatch")) continue;

    // Use renamed display text for swatch lookup
    var colour = map[displayText] || map[valueText] || "";

    // If not found, skip (keeps it clean and avoids wrong colours)
    if (!colour) continue;

    var sw = document.createElement("span");
    sw.className = "eg-colour-swatch";
    sw.style.background = colour;

    // Insert swatch right after the checkbox
    var cb = label.querySelector('input[type="checkbox"]');
    if (cb && cb.parentNode === label && cb.nextSibling) {
      label.insertBefore(sw, cb.nextSibling);
    } else if (cb && cb.parentNode === label) {
      label.appendChild(sw);
    } else {
      // Fallback
      label.insertBefore(sw, label.firstChild);
    }
  }
}

function egApplyShopifyFacetValueRenames(root) {
  if (!root) return;

  var ren = window.EG_FILTER_VALUE_RENAMES || {};
  if (!ren) return;

  // We only need vendor right now, but this supports any facet key you add.
  var facetKeys = Object.keys(ren);
  if (!facetKeys || !facetKeys.length) return;

  for (var i = 0; i < facetKeys.length; i++) {
    var facetKey = facetKeys[i];
    if (!facetKey || facetKey.indexOf("filter.") !== 0) continue; // only Shopify facets

    var map = ren[facetKey];
    if (!map) continue;

    var groups = root.querySelectorAll('.eg-filter-group[data-eg-filter-key="' + facetKey + '"]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];

      // options panel may be teleported into overlay (group.__egPanel)
      var panel = group.__egPanel || group.querySelector(".eg-filter-options");
      if (!panel) continue;

      var labels = panel.querySelectorAll("label.eg-filter-option");
      for (var l = 0; l < labels.length; l++) {
        var label = labels[l];

        var textEl =
          label.querySelector(".eg-filter-option-label") ||
          label.querySelector(".eg-filter-option-text") ||
          null;

        if (!textEl) continue;

        var raw = "";
        try { raw = (textEl.textContent || "").replace(/^\s+|\s+$/g, ""); } catch (e) {}
        if (!raw) continue;

        var next = map[raw] || raw;

        // IMPORTANT: only change visible text, never touch input.value
        if (next !== raw) textEl.textContent = next;
      }
    }
  }
}

function egApplyAppliedPillValueRenames(root) {
  // Pills live outside the filter group sometimes; use document-level query.
  var ren = window.EG_FILTER_VALUE_RENAMES || {};
  if (!ren) return;

  // Flatten all renames into one "from -> to" map.
  // (So vendor renames apply even if pill doesn't store the key.)
  var flat = {};
  for (var k in ren) {
    if (!ren.hasOwnProperty(k)) continue;
    var m = ren[k];
    if (!m) continue;
    for (var from in m) {
      if (!m.hasOwnProperty(from)) continue;
      flat[String(from)] = String(m[from]);
    }
  }

  var pills = document.querySelectorAll(".eg-applied-pills .eg-pill");
  if (!pills || !pills.length) return;

  for (var i = 0; i < pills.length; i++) {
    var pill = pills[i];

    // Don’t touch the "+N more" pill
    if (pill.classList && pill.classList.contains("eg-pill--more")) continue;

    // Prefer a dedicated label element if it exists
    var labelEl =
      pill.querySelector(".eg-pill-label") ||
      pill.querySelector(".eg-pill-text") ||
      pill.querySelector(".eg-pill-name") ||
      null;

    // If no label element, try to rewrite the first non-empty TEXT NODE
    if (!labelEl) {
      for (var n = 0; n < pill.childNodes.length; n++) {
        var node = pill.childNodes[n];
        if (node && node.nodeType === 3) {
          var txt = String(node.nodeValue || "").replace(/^\s+|\s+$/g, "");
          if (!txt) continue;

          var nextTxt = txt;
          for (var fromKey in flat) {
            if (!flat.hasOwnProperty(fromKey)) continue;
            if (nextTxt.indexOf(fromKey) !== -1) nextTxt = nextTxt.split(fromKey).join(flat[fromKey]);
          }

          if (nextTxt !== txt) node.nodeValue = node.nodeValue.replace(txt, nextTxt);
          break;
        }
      }
      continue;
    }

    // Rewrite label text (keep the X button etc intact)
    var raw = String(labelEl.textContent || "").replace(/^\s+|\s+$/g, "");
    if (!raw) continue;

    var next = raw;
    for (var fromKey2 in flat) {
      if (!flat.hasOwnProperty(fromKey2)) continue;
      if (next.indexOf(fromKey2) !== -1) next = next.split(fromKey2).join(flat[fromKey2]);
    }

    if (next !== raw) labelEl.textContent = next;
  }
}

function renderTagGroups(root) {
  if (!root) return;

  // pull rule from config (we'll define getRuleForRoot in eg-collections-ux.js later)
  if (typeof getRuleForRoot !== "function") return;
  const rule = getRuleForRoot(root);
  if (!rule || !Array.isArray(rule.tagGroups) || !rule.tagGroups.length) return;

  if (typeof egBuildTagHandleLookup !== "function") return;
  const tagToHandle = egBuildTagHandleLookup(); // Map(fullTag -> handle)
  if (!tagToHandle || !tagToHandle.size) return;

  const allTags = Array.from(tagToHandle.keys());

  const activeEg = (typeof egReadActiveEgTagParams === "function")
    ? egReadActiveEgTagParams()
    : new Map();

  const host = (typeof ensureTagGroupsContainer === "function")
    ? ensureTagGroupsContainer(root)
    : root;

  // Remove any previous tag groups (safe re-render)
  host.querySelectorAll('.eg-filter-group[data-eg-kind="tag"], .eg-filter-group[data-eg-kind="tagset"]').forEach(n => n.remove());

  // Build individual groups
  const builtByKey = new Map();

  rule.tagGroups.forEach(groupDef => {
    const onlyTags = Array.isArray(groupDef?.match?.onlyTags) ? groupDef.match.onlyTags : null;
    const startsWith = groupDef?.match?.startsWith;
    const excludeStartsWith = Array.isArray(groupDef?.match?.excludeStartsWith) ? groupDef.match.excludeStartsWith : [];

    let matches = [];

    if (onlyTags && onlyTags.length) {
      matches = onlyTags.filter(t => allTags.includes(t));
    } else {
      if (!startsWith) return;

      matches = allTags
        .filter(t => {
          if (typeof t !== "string") return false;
          if (!t.startsWith(startsWith)) return false;

          // Exclusions from config (e.g. Compatible with_ should ignore Compatible with__)
          for (var xi = 0; xi < excludeStartsWith.length; xi++) {
            var ex = String(excludeStartsWith[xi] || "");
            if (ex && t.startsWith(ex)) return false;
          }

          // Ignore any double-underscore Game Type tags (Game Type__...)
          if (startsWith === "Game Type_" && t.startsWith("Game Type__")) return false;

          return true;
        })
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
    }

    // Hide useless placeholder values like "-" across all EG tag filters
    matches = matches.filter(function (t) {
      return !isEgEmptyValueTag(t, startsWith);
    });

    if (!matches.length) return;

    const numCfg = egGetNumericSliderCfgForStartsWith(startsWith);

    const group = document.createElement("div");
    group.className = "eg-filter-group";
    group.setAttribute("data-eg-kind", "tag");
    group.setAttribute("data-eg-tag-group", groupDef.key || "");
    group.setAttribute("data-eg-filter-key", "tag." + (groupDef.key || ""));

    const title = document.createElement("div");
    title.className = "eg-filter-title";
    title.textContent = groupDef.label || groupDef.key || "Filter";
    group.appendChild(title);

    const options = document.createElement("div");
    options.className = "eg-filter-options";
    options.setAttribute("data-eg-managed", "1");

        // Toggle group (single checkbox directly on the bar)
    if (!numCfg && groupDef.ui === "toggle" && matches.length === 1) {
      group.classList.add("eg-filter-group--toggle");

      const fullTag = matches[0];
      const label = document.createElement("label");
      label.className = "eg-filter-option eg-filter-toggle";

      const input = document.createElement("input");
      input.type = "checkbox";
      input.dataset.egKind = "tag";
      input.dataset.egTagGroup = groupDef.key || "";
      input.dataset.egMode = groupDef.mode || "single";
      input.value = fullTag;

      const tagHandle = tagToHandle.get(fullTag) || "";
      input.dataset.egTagHandle = tagHandle;

      const gk = groupDef.key || "";
      const set = activeEg.get(gk);
      if (tagHandle && set && set.has(tagHandle)) input.checked = true;

      label.appendChild(input);

      const text = document.createElement("span");
      text.className = "eg-filter-option-label";
      text.textContent = groupDef.label || groupDef.key || "Dots";
      label.appendChild(text);

      const count = document.createElement("span");
      count.className = "eg-filter-option-count";
      count.textContent = "(0)";
      label.appendChild(count);

      // Replace the normal title/options UI with the toggle
      group.innerHTML = "";
      group.appendChild(label);

      host.appendChild(group);
      if (groupDef.key) builtByKey.set(groupDef.key, { def: groupDef, el: group });
      return;
    }

    // If this group is numeric (Length_/Width_/Area_) render a slider instead of checkboxes
    if (numCfg && window.noUiSlider) {
      var nums = matches
        .map(function (t) {
          var tail = String(t).slice(String(startsWith).length);

          // Ignore range-style tags like "9511mm-1200mm" (or en-dash),
          // but allow a leading negative sign like "-42dB".
          if (tail.indexOf("–") !== -1) return null;

          var hy = tail.indexOf("-");
          if (hy > 0) return null;                 // "-" after first char => range/junk
          if (hy === 0 && tail.slice(1).indexOf("-") !== -1) return null; // "-x-y" => range/junk

          // Take the FIRST numeric token only (safe for "-42dB", "420mm")
          var m = tail.match(/(-?\d*\.?\d+)/);
          if (!m) return null;
          if (!m[1] || m[1] === ".") return null;

          var n = parseFloat(m[1]);
          return isNaN(n) ? null : n;
        })
        .filter(function (v) { return v !== null; })
        .sort(function (a, b) { return a - b; });

      if (!nums.length) return;

      var minVal = nums[0];
      var maxVal = nums[nums.length - 1];
      var curr = egGetNumericRangeFromUrl(numCfg.param, minVal, maxVal);

      var wrap = document.createElement("div");
      // Mark the actual slider UI node (survives overlay move + tagset child moving)
      wrap.setAttribute("data-eg-range-param", String(numCfg.param || ""));
      wrap.setAttribute("data-eg-range-min", String(minVal));
      wrap.setAttribute("data-eg-range-max", String(maxVal));
      wrap.setAttribute("data-eg-range-unit", String(numCfg.unit || ""));

      wrap.className = "eg-range-wrap";
      wrap.innerHTML =
        '<div class="eg-range-label">' + (groupDef.label || groupDef.key || "") + '</div>' +
        '<div class="eg-range-inputs">' +
          '<input class="eg-range-min" type="number" step="' + (numCfg.step || 1) + '">' +
          '<span class="eg-range-dash">–</span>' +
          '<input class="eg-range-max" type="number" step="' + (numCfg.step || 1) + '">' +
          '<span class="eg-range-unit">' + (numCfg.unit || "") + '</span>' +
        '</div>' +
        '<div class="eg-range-slider"></div>';

      options.appendChild(wrap);

      var minInput = wrap.querySelector(".eg-range-min");
      var maxInput = wrap.querySelector(".eg-range-max");
      var sliderEl = wrap.querySelector(".eg-range-slider");

      minInput.value = String(curr.min);
      maxInput.value = String(curr.max);

      noUiSlider.create(sliderEl, {
        start: [curr.min, curr.max],
        connect: true,
        range: { min: minVal, max: maxVal },
        step: numCfg.step || 1
      });

      sliderEl.noUiSlider.on("update", function (values, handle) {
        var v = parseFloat(values[handle]);

        // Format according to step precision
        var step = numCfg.step || 1;
        var decimals = 0;

        if (step && step < 1) {
          var parts = String(step).split(".");
          decimals = (parts.length > 1) ? parts[1].length : 1;
        }

        var formatted = (decimals > 0)
          ? v.toFixed(decimals)
          : Math.round(v).toString();

        if (handle === 0) minInput.value = formatted;
        else maxInput.value = formatted;
      });

      sliderEl.noUiSlider.on("set", function () {
        if (window.__egSuppressRangeUrlWrite) return;
        var a = parseFloat(minInput.value);
        var b = parseFloat(maxInput.value);
        if (isNaN(a)) a = minVal;
        if (isNaN(b)) b = maxVal;

        // Snap to step to avoid float mismatch (fixes "looks reset but URL not cleared")
        var step = parseFloat(numCfg.step);
        if (isNaN(step) || step <= 0) step = 1;

        function snapToStep(v) {
          return Math.round(v / step) * step;
        }

        a = snapToStep(a);
        b = snapToStep(b);

        // Keep inputs consistent with snapped values
        minInput.value = a;
        maxInput.value = b;

        // If user returns to full range, remove the param entirely (so Clear button hides)
        if (a <= minVal && b >= maxVal) {
          egSetUrlParamNoReload(numCfg.param, "");
        } else {
          egSetUrlParamNoReload(numCfg.param, a + "-" + b);
        }

        if (root && typeof root.__egClientRenderRefresh === "function") {
          root.__egClientRenderRefresh();
        }
        if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
        if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
      });

      minInput.addEventListener("change", function () {
        sliderEl.noUiSlider.set([minInput.value, null]);
      });

      maxInput.addEventListener("change", function () {
        sliderEl.noUiSlider.set([null, maxInput.value]);
      });

    } else {
      // Existing checkbox list (unchanged)
      matches.forEach(function (fullTag) {
        var label = document.createElement("label");
        label.className = "eg-filter-option eg-filter-toggle";

        var input = document.createElement("input");
        input.type = "checkbox";
        input.dataset.egKind = "tag";
        input.dataset.egTagGroup = groupDef.key || "";
        input.dataset.egMode = groupDef.mode || "single";
        input.value = fullTag;

        var tagHandle = tagToHandle.get(fullTag) || "";
        input.dataset.egTagHandle = tagHandle;

        var gk = groupDef.key || "";
        var set = activeEg.get(gk);
        if (tagHandle && set && set.has(tagHandle)) input.checked = true;

        label.appendChild(input);

        var text = document.createElement("span");
        text.className = "eg-filter-option-label";
        if (typeof formatTagLabel === "function") text.textContent = formatTagLabel(fullTag, startsWith);
        else text.textContent = fullTag;

        var count = document.createElement("span");
        count.className = "eg-filter-option-count";
        count.textContent = "(0)";

        label.appendChild(text);
        label.appendChild(count);

        options.appendChild(label);
      });
    }

    group.appendChild(options);
    if (groupDef.key) builtByKey.set(groupDef.key, { def: groupDef, el: group });
  });

  // Tag group sets (Performance / Base & Build / Style in your config)
  const sets = Array.isArray(rule.tagGroupSets) ? rule.tagGroupSets : [];
  const usedChildKeys = new Set();

  function isEgEmptyValueTag(fullTag, startsWith) {
    if (!fullTag || !startsWith) return false;

    var tail = String(fullTag).slice(String(startsWith).length);
    tail = tail.replace(/^\s+|\s+$/g, "");

    // Treat empty / placeholder values as "no data"
    if (!tail) return true;
    if (tail === "-" || tail === "–" || tail === "—") return true;

    // If formatter collapses it to "-" then also hide it
    if (typeof formatTagLabel === "function") {
      try {
        var lbl = String(formatTagLabel(fullTag, startsWith) || "").replace(/^\s+|\s+$/g, "");
        if (lbl === "-" || lbl === "–" || lbl === "—") return true;
      } catch (e) {}
    }

    return false;
  }


  function egCreateTagSetGroupEl(setDef, childGroupEls) {
    const group = document.createElement("div");
    group.className = "eg-filter-group";
    group.setAttribute("data-eg-kind", "tagset");
    group.setAttribute("data-eg-tagset-key", setDef.key || "");
    group.setAttribute("data-eg-filter-key", "tagset." + (setDef.key || ""));

    const title = document.createElement("div");
    title.className = "eg-filter-title";
    title.textContent = setDef.label || setDef.key || "Filter";
    group.appendChild(title);

    const options = document.createElement("div");
    options.className = "eg-filter-options";
    options.setAttribute("data-eg-managed", "1");

    childGroupEls.forEach(({ def, el }) => {
      const section = document.createElement("div");
      section.className = "eg-filter-subgroup";

      const h = document.createElement("div");
      h.className = "eg-filter-subtitle";
      h.textContent = def.label || def.key || "Options";
      section.appendChild(h);

      const childOptions = el.querySelector(".eg-filter-options");
      if (childOptions) {
        while (childOptions.firstChild) section.appendChild(childOptions.firstChild);
      }

      options.appendChild(section);
    });

    group.appendChild(options);
    return group;
  }

  sets.forEach(setDef => {
    const childKeys = Array.isArray(setDef.children) ? setDef.children : [];
    const childEls = [];

    childKeys.forEach(k => {
      const found = builtByKey.get(k);
      if (!found) return;
      usedChildKeys.add(k);
      childEls.push(found);
    });

    if (!childEls.length) return;

    const parent = egCreateTagSetGroupEl(setDef, childEls);
    host.appendChild(parent);
  });

  // Remaining groups
  builtByKey.forEach((obj, k) => {
    if (usedChildKeys.has(k)) return;
    host.appendChild(obj.el);
  });

  egApplyColourSwatches(root);
}

function egComputeCountsForEachTagOption(products, root) {
  const shopifySel = egGetActiveShopifyFacetSelections(root);
  const egTagSel = egGetActiveEgTagSelections(root);

  // Count tags for products that match NON-EG facets first
  const emptyEgSel = new Map();
  const base = products.filter(p => egProductMatchesSelections(p, shopifySel, emptyEgSel));

    // Apply availability facet from URL so counts respond to In stock / Out of stock selection
  function applyAvailabilityFromUrl(arr) {
    const sp = new URLSearchParams(window.location.search || "");
    const vals = sp.getAll("filter.v.availability");
    if (!vals || !vals.length) return arr;

    let wantIn = false;
    let wantOut = false;

    for (const raw of vals) {
      const v = String(raw || "").trim();
      if (v === "1" || v === "true") wantIn = true;
      if (v === "0" || v === "false") wantOut = true;
    }

    // both selected => no-op
    if (wantIn && wantOut) return arr;

    return (arr || []).filter(p => {
      let ok = true;
      try { ok = egGetLiteAvailable(p); } catch (e) {}
      if (wantIn) return !!ok;
      if (wantOut) return !ok;
      return true;
    });
  }

  const baseAvail = applyAvailabilityFromUrl(base);

  const counts = new Map(); // normalizedTag -> count

  for (const p of baseAvail) {
    if (!p || !Array.isArray(p.tags)) continue;
    for (const t of p.tags) {
      if (typeof t !== "string") continue;
      const k = egNormalizeTagKey(t);
      if (!k) continue;
      counts.set(k, (counts.get(k) || 0) + 1);
    }
  }

  // If no EG tags selected, global counts are enough
  const anyEgSelected = Array.from(egTagSel.values()).some(s => s && s.size);
  if (!anyEgSelected) {
    return { globalCounts: counts, perGroupCounts: null };
  }

  // Otherwise, build per-group counts that ignore the group's own selection
  const perGroupCounts = new Map(); // groupKey -> Map(normalizedTag -> count)

  const groups = new Set();
  root.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"]').forEach(input => {
    const gk = String(input.dataset.egTagGroup || "");
    if (gk) groups.add(gk);
  });

  for (const groupKey of groups) {
    const egSelMinus = new Map();
    for (const [k, set] of egTagSel.entries()) {
      if (k === groupKey) continue;
      egSelMinus.set(k, set);
    }

    const baseMinus0 = products.filter(p => egProductMatchesSelections(p, shopifySel, egSelMinus));
    const baseMinus = applyAvailabilityFromUrl(baseMinus0);
    const m = new Map();

    for (const p of baseMinus) {
      if (!p || !Array.isArray(p.tags)) continue;
      for (const t of p.tags) {
        if (typeof t !== "string") continue;
        const k = egNormalizeTagKey(t);
        if (!k) continue;
        m.set(k, (m.get(k) || 0) + 1);
      }
    }

    perGroupCounts.set(groupKey, m);
  }

  return { globalCounts: counts, perGroupCounts };
}

async function egUpdateEgTagGroupCountsAndDisabledFromLite(root) {
  if (!root) return;

  const handle = String(root.dataset.egCollection || "");
  if (!handle) return;

  const products = await egGetFullCollectionProducts(handle);
  if (!products || !products.length) return;

  const { globalCounts, perGroupCounts } = egComputeCountsForEachTagOption(products, root);

  root.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"]').forEach(input => {
    const label = input.closest("label.eg-filter-option");
    if (!label) return;

    const groupKey = String(input.dataset.egTagGroup || "");
    const fullTag = String(input.value || "").trim();
    const key = egNormalizeTagKey(fullTag);

    const mapToUse =
      (perGroupCounts && groupKey && perGroupCounts.get(groupKey))
        ? perGroupCounts.get(groupKey)
        : globalCounts;

    const c = key ? (mapToUse.get(key) || 0) : 0;

    const countEl = label.querySelector(".eg-filter-option-count");
    if (countEl) countEl.textContent = `(${c})`;

    const shouldDisable = (c === 0 && !input.checked);
    input.disabled = shouldDisable;
    label.classList.toggle("is-disabled", shouldDisable);
  });

  egApplyColourSwatches(root);
}

